module.exports = __webpack_public_path__ + "img/approval.d1fe03fc.svg";